export const INITIALIZE = 'com.QuieroMatch.common.INITIALIZE';
export const SET_LOADING = 'com.QuieroMatch.common.SET_LOADING';
export const CLEAR = 'com.QuieroMatch.common.CLEAR';
